@if (!notificationBannerHistory) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<h2 class="banner-title">Message History</h2>
@if (notificationBannerHistory) {
  <p-table
    #dt
    [value]="notificationBannerHistory"
    selectionMode="single"
    [loadingIcon]="loadingIcon"
    [showLoader]="true"
    [scrollable]="true"
    [style]="{ width: '100%' }"
    scrollHeight="550px"
    dataKey="notificationBannerID"
    [paginator]="true"
    [rows]="10"
    [pageLinks]="5"
    paginatorPosition="bottom"
    class="table">
    <ng-template #header>
      <tr class="row">
        <th class="headercell collarge">Message</th>
        <th [pSortableColumn]="'createdOn'" class="headercell">
          Created Date <p-sortIcon [field]="'createdOn'"> </p-sortIcon>
        </th>
        <th class="headercell">Created By</th>
      </tr>
    </ng-template>
    <ng-template #body let-rowData>
      <tr class="row">
        <td class="collarge">
          <span>{{ rowData.description }}</span>
        </td>
        <td>
          <span>{{ rowData.createdOn | date: 'short' }}</span>
        </td>
        <td>
          <span>{{ rowData.createdByUser.fullName }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
